import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { GraduationCap, Mic, ClipboardList, Mail, ArrowRight, Flame } from "lucide-react";

export const TutorPromoCard = () => {
  const navigate = useNavigate();
  const perks = [
    { icon: Mic, text: "Talks & listens — real teacher voice, kids just speak their doubts" },
    { icon: ClipboardList, text: "Practice quizzes after every chapter, with re-teaching of mistakes" },
    { icon: Flame, text: "Daily streaks & badges that make studying a habit" },
    { icon: Mail, text: "Weekly report card emailed to parents automatically" },
  ];
  return (
    <section className="py-24 px-6 relative overflow-hidden" data-testid="tutor-promo-section">
      <div className="max-w-6xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="relative rounded-3xl border border-cyan-400/25 bg-gradient-to-br from-cyan-500/10 via-[#0A0A0A] to-purple-500/10 p-8 sm:p-12 overflow-hidden"
        >
          <div className="absolute -top-20 -right-20 w-72 h-72 rounded-full bg-cyan-500/10 blur-3xl pointer-events-none" />
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center relative">
            <div>
              <span className="inline-flex items-center gap-2 px-3 py-1 rounded-full text-[11px] font-bold uppercase tracking-wider bg-cyan-500/15 border border-cyan-400/40 text-cyan-200 mb-5">
                <GraduationCap size={13} /> New · ShansoTutor
              </span>
              <h2 className="text-3xl sm:text-4xl font-black text-white leading-tight mb-4">
                Your child's personal <span style={{ background: "linear-gradient(90deg, #00F0FF, #7000FF)", WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent" }}>AI tuition teacher</span>
              </h2>
              <p className="text-[#A1A1AA] text-base mb-6 max-w-md">
                Classes 6–12 · CBSE · Maths &amp; Science. A patient teacher that explains step by step,
                asks questions back, and never gets tired — for a fraction of tuition fees.
              </p>
              <button
                onClick={() => navigate("/tutor")}
                data-testid="tutor-promo-cta"
                className="inline-flex items-center gap-2 px-7 py-3.5 rounded-full font-bold text-black transition-transform hover:scale-[1.03]"
                style={{ background: "linear-gradient(135deg, #00F0FF, #22D3EE)" }}
              >
                Try ShansoTutor free <ArrowRight size={16} />
              </button>
            </div>
            <div className="space-y-3">
              {perks.map((p, i) => (
                <motion.div
                  key={i}
                  initial={{ opacity: 0, x: 24 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.4, delay: 0.1 * i }}
                  className="flex items-center gap-3 rounded-2xl border border-zinc-800 bg-[#0A0A0A]/80 px-4 py-3.5"
                >
                  <div className="w-9 h-9 rounded-xl bg-cyan-500/10 border border-cyan-400/25 flex items-center justify-center shrink-0">
                    <p.icon size={16} className="text-cyan-300" />
                  </div>
                  <p className="text-sm text-zinc-300">{p.text}</p>
                </motion.div>
              ))}
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};
